var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isAllActionItemInvalid && !_vm.messageItem.hasRiskContent ? _c('div', {
    ref: "messageToolDom",
    class: ['dialog-item', !_vm.isPC ? 'dialog-item-h5' : 'dialog-item-web']
  }, [_c('div', {
    staticClass: "dialog-item-list",
    class: !_vm.isPC ? 'dialog-item-list-h5' : 'dialog-item-list-web'
  }, [_vm._l(_vm.actionItems, function (item, index) {
    return [item.renderCondition() ? _c('div', {
      key: item.key,
      staticClass: "list-item",
      on: {
        "click": function ($event) {
          return _vm.getFunction(index);
        },
        "mousedown": function ($event) {
          return _vm.beforeCopy(item.key);
        }
      }
    }, [_c('Icon', {
      attrs: {
        "file": item.iconUrl,
        "size": '15px'
      }
    }), _c('div', {
      staticClass: "list-item-text"
    }, [_vm._v(_vm._s(item.text))])], 1) : _vm._e()];
  })], 2)]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }